import React from 'react'
import 'bootstrap-icons/font/bootstrap-icons.css'
import styles from './styles.module.scss'

interface SocialLink {
    icon: string
    label: string
    url: string
}

const SocialMedia: React.FC = () => {
    const socialLinks: SocialLink[] = [
        {
            icon: 'bi-instagram',
            label: 'Instagram',
            url: 'https://www.instagram.com/sentinellegal_',
        },
        {
            icon: 'bi-linkedin',
            label: 'LinkedIn',
            url: 'https://www.linkedin.com/company/sentinel-legal/',
        },
        {
            icon: 'bi-youtube',
            label: 'YouTube',
            url: 'https://www.youtube.com/@sentinellegal',
        },
        {
            icon: 'bi-tiktok',
            label: 'TikTok',
            url: 'https://www.tiktok.com/@sentinellegal?_t=8qYCIFDNRjM&_r=1',
        },
        {
            icon: 'bi-spotify',
            label: 'Spotify',
            url: 'https://open.spotify.com/show/57XQn5Id8SKgPx83YmtJ1V',
        },
    ]

    return (
        <div className={styles.socialContainer}>
            {socialLinks.map((link) => (
                <a
                    key={link.label}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.socialLink}
                    aria-label={link.label}
                    title={link.label}
                >
                    <i className={`bi ${link.icon}`}></i>
                </a>
            ))}
        </div>
    )
}

export default SocialMedia
